import { Module, ActionContext } from "vuex"
import util from "@/lib/util"
import { router } from "@/router"
import ajax from "@/lib/ajax"
import AppConsts from "@/lib/appconst"
import { AbpApiResponse } from "@/store/models/common";
import { GetApplicantProfileByUserIdOutput } from "@/store/models/publicUserProfile/GetApplicantProfileByUserIdOutput"
import { AuthenticateResultModel, AuthenticateModel, ICustomerUserProfileStateDto } from "@/asdcom/apiproxy/apiproxy.dto"
import AbpBase from "@/lib/abpbase"

const _hostUrl = "https://ocvcapp-api-dev.heart4victims.org";

interface AppState {
  //moved from "index"
  source: "OCVCApp"
  loading: boolean
  loadings: number
  routeCameFromSummary: null
  query: null
  from: null

  //moved from "app"
  tenantInfo: any
  crimeTypes: any
  quickLinksList: any
  userId: null | number

  // moved from "applicant"
  applicantProfile?: GetApplicantProfileByUserIdOutput
   userProfileFlags?: ICustomerUserProfileStateDto
  // isSecQuestionsCompleted: boolean
  // isContactInfoCompleted: boolean
  // isPersonalInfoCompleted: boolean


  // moved from "session"
  application: any;
  user: any;
  tenant: any;
  userName?: string;

}

// interface TokenChangeInput {
// 	tokeExpDate: Date, tokenDurationSeconds: number
// }
interface TokenExpirationChangeInput {
	tokenExpDate: Date,
}
interface TokenDurationChangeInput {
	tokenDurationSeconds: number,
}


class AppStore implements Module<AppState, any> {
  namespaced = true
  state: AppState = {
    source: "OCVCApp",
    loading: false,
    loadings: 0,
    routeCameFromSummary: null,
    query: null,
    from: null,

    tenantInfo: null,
    crimeTypes: null,
    quickLinksList: null,
    userId: null,

    applicantProfile: undefined,
    userProfileFlags: undefined,
    // isSecQuestionsCompleted: false,
    // isContactInfoCompleted: false,
    // isPersonalInfoCompleted: false,

    application: null,
    tenant: null,
    user: null,
    userName: "",
}
  getters = {

    //moved from "applicant"
    applicantProfileId(context: any) {
      return context.applicantProfile ? context.applicantProfile.id : null
    },

    // moved from "index"
    buildInfo(state: any, context: any, rootState: any): string {
      // abp.log.debug({"asdcom.app.ts rootState.session":rootState.session});
      const application = rootState.session && rootState.session.application ? rootState.session.application : null
      const version = application && application.version ? application.version : "-"
      const releaseDate = application ? util.formatDate(application.releaseDate) : "-"
      
      const versionText = "V{0}".replace("{0}", version)
      const buildDateText = " Build [{0}]".replace("{0}", releaseDate)
      return `${versionText} ${buildDateText}`
    },
  }
  mutations = {
      // moved from "session"
      tokenDuration(state: AppState, payload: TokenDurationChangeInput) {
        localStorage.setItem(AppConsts.authorization.tokenDurationSecondsName, payload.tokenDurationSeconds.toString());
    },
    tokenExpiration(state: AppState, payload: TokenExpirationChangeInput) {
        localStorage.setItem(AppConsts.authorization.tokenExpName, payload.tokenExpDate.toString());
    },

    timeout(state: AppState) {
        util.abp.utils.setCookieValue(AppConsts.authorization.isTimeoutCookieName, true, null, util.abp.appPath, util.abp.domain);
    },
    authInitiated(state: AppState, payload: { authModel: AuthenticateModel }) {
        state.userName = payload.authModel.userNameOrEmailAddress;
    },

    // switchLanguage(state: AppState) {
    //     const token = window.abp.auth.getToken();
    //     util.abp.utils.setCookieValue(`${appconst.authorization.encrptedAuthTokenName}_backup`, token, new Date(new Date().getTime() + 5 * 365 * 86400000), util.abp.appPath)
    //     window.abp.auth.clearToken();
    // },
    logout(state: AppState, ) {
        state.application = null;
        state.user = null;
        //state.userId = null;
        util.abp.utils.deleteCookie(AppConsts.authorization.encrptedAuthTokenName, util.abp.appPath);
        util.abp.utils.deleteCookie("userId", util.abp.appPath);
        window.abp.auth.clearToken();
        localStorage.clear();
        sessionStorage.clear();
    },

    //moved from "applicant" store
    applicantProfileDataChange(state: AppState, payload: GetApplicantProfileByUserIdOutput) {
      state.applicantProfile = payload
    },
    userProfileFlagsChange(state: AppState, payload: ICustomerUserProfileStateDto) {
      state.userProfileFlags = payload
      // if (!!payload) {
      //   state.isContactInfoCompleted = payload.isCompleteContactInfo
      //   state.isPersonalInfoCompleted = payload.isCompletePersonalInfo
      //   state.isSecQuestionsCompleted = payload.isCompleteSecurityQuestions
      // }
    },

    // Moved from "index.ts" store.
    addLoader(state: AppState) {
      state.loadings += 1
      if (state.loadings > 0) {
        state.loading = true
      }
    },
    deleteLoader(state: AppState) {
      state.loadings = state.loadings ? 0 : (state.loadings -= 1)
      if (state.loadings < 1) {
        state.loading = false
      }
    },
  }
  actions = {

    // Moved from "session" store module.

    /// log out must happen immediate, so the function is not async.
    logout(context: ActionContext<AppState, any>) {
      // save token for server logout.
      const token = window.abp.auth.getToken()
      // client logout/clear session.
      context.commit("logout")
      // server logout.
      return ajax.post("/api/services/app/Account/Logout", {}, { headers: { Authorization: "Bearer " + token } }).then((rep: any) => {
        const ret = (rep && rep.data && rep.data.success) || null
        abp.log.debug({ "asdcom/app/logout": { "server logout success": rep.data } })
        return ret
      })
    },

    // async refreshAuthToken(context: ActionContext<AppState, any>) {
    //     const rep = await ajax.post<AbpApiResponse<string>>("/api/TokenAuth/RefreshJWTToken");
    //     abp.log.debug({ "refreshAuthToken": rep.data.result });

    //     const tokenDuration: number = context.rootGetters["session/tokenDurationSeconds"]
    //     const tokenExp = new Date(new Date().getTime() + 1000 * tokenDuration);

    //     if (tokenExp != undefined) {
    //         // update token value.
    //         util.abp.auth.setToken(rep.data.result, tokenExp);
    //         //util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, util.abp.appPath);

    //         // store new expiration.
    //         context.commit("tokenExpiration", { tokenExpDate: tokenExp })
    //     }
    //     else{
    //         context.dispatch("logout")
    //     }

    // },
   
    
    // timeout(context: ActionContext<AppState, any>) {
    //     context.commit("timeout");
    //     context.dispatch("logout");
    // },

    

    // Moved from "applicant" store module.
   
    // async getUserProfileFlags_OLD(context: ActionContext<AppState, any>) {
    //   abp.log.debug(`public-user/getUserProfileFlags called ***************`)
    //   if (context.state.userProfileFlags === undefined) {
    //     abp.log.debug("getting UserProfileFlags from server...")
    //     await context.dispatch("refreshUserProfileFlags")
    //   }
    //   abp.log.debug({ userProfileFlags: context.state.userProfileFlags })
    //   return context.state.userProfileFlags
    // },

    // async refreshUserProfileFlags(context: ActionContext<AppState, any>) {
    //   abp.log.debug(`public-user/refreshUserProfileFlags called *********** UserId: ${util.abp.session.userId}`)
    //   let userId = util.abp.session.userId

    //   if (!!userId) {
    //     let res = await ajax.get("/api/services/app/publicUserProfile/GetPublicUserProfileReadyFlags", {
    //       params: {
    //         userId,
    //         preventCache: new Date().getTime(),
    //       },
    //     })

    //     context.commit("userProfileFlagsChange", res.data.result)
    //     //abp.log.debug({"userProfileFlags":context.state.userProfileFlags});
    //     return res.data.result
    //   }
    // },

    // async updateSecurityQuestions(context: ActionContext<AppState, any>, payload: any) {
    //   const data = payload.data
    //   let response: any = await ajax.put(`/api/services/app/Account/UpdateSecurityQuestions`, data)
    //   context.commit("applicantProfileDataChange", response.data.result)

    //   const result = response && response.data && response.data.result ? response.data.result : null
    //   context.dispatch("refreshUserProfileFlags")

    //   return result
    // },

    // async updateApplicantProfileContactInfo(context: ActionContext<AppState, any>, payload: any) {
    //   const id = context.getters["applicantProfileId"]
    //   const data = payload.data
    //   let response: any = await ajax.put(`/api/services/app/ApplicantProfile/UpdateApplicantProfileContactInfo?id=${id}`, data)
    //   context.commit("applicantProfileDataChange", response.data.result)
    //   const result = response && response.data && response.data.result ? response.data.result : null

    //   context.dispatch("refreshUserProfileFlags")
    //   return result
    // },
    // async updateApplicantProfilePreferences(context: ActionContext<AppState, any>, payload: any) {
    //   const id = context.getters["applicantProfileId"]
    //   const data = payload.data
    //   let response: any = await ajax.put(`/api/services/app/ApplicantProfile/UpdateApplicantProfilePreferences?id=${id}`, data)
    //   context.commit("applicantProfileDataChange", response.data.result)

    //   const result = response && response.data && response.data.result ? response.data.result : null

    //   context.dispatch("refreshUserProfileFlags")
    //   return result
    // },

    // async updateApplicantProfilePersonalInfo(context: ActionContext<AppState, any>, payload: any) {
    //   const id = context.getters["applicantProfileId"]
    //   let data = payload.data
      
    //   //copy email address from user account.
    //   const user = context.rootGetters["asdcom/session/currentUser"]
    //   console.log(context.rootGetters)
    //   data.email = user.emailAddress
      
    //   let response: any = await ajax.put(`/api/services/app/ApplicantProfile/UpdateApplicantProfilePersonalInfo?id=${id}`, data)
    //   context.commit("applicantProfileDataChange", response.data.result)

    //   const result = response && response.data && response.data.result ? response.data.result : null
    //   context.dispatch("refreshUserProfileFlags")

    //   return result
    // },

    
    // async getApplicantProfileByUserId(context: ActionContext<AppState, any>): Promise<GetApplicantProfileByUserIdOutput> {
    //   // const user = context.rootGetters["session/currentUser"];
    //   // // abp.log.debug(`getApplicantProfileByUserId ***************`)
    //   // //abp.log.debug(`sessionStorage userId: ${sessionStorage.getItem("userId")}`)
    //   // //abp.log.debug(user);
    //   // // if (context.state.applicantProfile != undefined && !user && user.id === sessionStorage.getItem("userId")){
    //   // //   console.log("returning applicantProfile from MEMORY.", context.state.applicantProfile);
    //   // //   return context.state.applicantProfile;
    //   // // } else {
    //   // //const userId = context.rootState.session.user.id;
    //   // if (!user || !user.id) {
    //   //   //console.error("getter session/currentUser:", user);
    //   //   throw "Could not get user.id from session/currentUser.";
    //   // }
    //   // // const userId = user.id;

    //   // if profile is in memory return it.
    //   if (context.state.applicantProfile !== undefined) {
    //     return context.state.applicantProfile
    //   } else {
    //     const userId = util.abp.session.userId
    //     abp.log.debug(`trying to get user profile from SERVER for userId: ${userId}`)
    //     let response = await ajax.get("/api/services/app/ApplicantProfile/GetApplicantProfileByUserId", {
    //       params: {
    //         userId: userId,
    //         preventCache: new Date().getTime(),
    //       },
    //     })
    //     const result = response && response.data && response.data.result ? response.data.result : null
    //     context.commit("applicantProfileDataChange", result)

    //     return result
    //   }
    // },

    async getCrimeCaseApplicationPdfById(context: ActionContext<AppState, any>, payload: any) {
      let response: any = await ajax.get("/api/services/app/Applicant/GetCrimeCaseApplicationPdfById", {
        params: payload.data,
      })
      //console.warn('GetCrimeCaseApplicationPdfById', response);
      return response
    },
    async getResoursesByLatLong(context: ActionContext<AppState, any>, payload: any) {
      let reponse = await ajax.get("/api/services/app/Organization/GetResoursesByPostalCode", { params: payload.data })

      return reponse
    },
    async getResoursesByPostalCode(context: ActionContext<AppState, any>, payload: any) {
      let reponse = await ajax.get("/api/services/app/Organization/GetResoursesByPostalCode", { params: payload.data })
      return reponse
    },
    async getReadyApplicantProfileByUserId(context: ActionContext<AppState, any>) {
      //console.log("public-user/getReadyApplicantProfileByUserId:",context)
      return context.getters["application/userProfileFlags"]
    },

    // Actions moved from "app" store module.
    
    // async getUserNotifications(content: ActionContext<AppState, any>, payload: any) {
    //   let response = await ajax.get("/api/services/app/Notification/GetUserNotifications", {
    //     params: payload.data,
    //   })

    //   const result = response && response.data && response.data.result ? response.data.result : null
    //   return result
    // },
    // async getNotificationSettings(content: ActionContext<AppState, any>) {
    //   let rep = await ajax.get("/api/services/app/Notification/GetUserNotifications")
    //   return rep
    // },
    // async updateNotificationSettings(content: ActionContext<AppState, any>, payload: any) {
    //   let rep = await ajax.put("/api/services/app/Notification/UpdateNotificationSettings", payload.data)
    //   return rep
    // },
    async getAllCrimeTypes(content: ActionContext<AppState, any>) {
      // let CrimeTypes = content.state.crimeTypes || abp.utils.getCookieValue('CrimeTypes');
      let CrimeTypes = content.state.crimeTypes
      if (!CrimeTypes) {
        let rep = await ajax.get("/api/services/app/CrimeType/GetAllCrimeTypes")
        return (content.state.crimeTypes = rep.data && rep.data.result ? rep.data.result : null)
      }
      return CrimeTypes
    },
    async getQuickLinks(content: ActionContext<AppState, any>) {
      // let QuickLinks = content.state.quickLinksList || abp.utils.getCookieValue('QuickLinks');
      let QuickLinks = content.state.quickLinksList
      if (!QuickLinks) {
        let rep = await ajax.get("/api/services/app/QuickLinks/GetQuickLinks")
        return (content.state.quickLinksList = rep && rep.data ? rep.data.result : null)
      }
      return QuickLinks
    },
    
    async login(context: ActionContext<AppState, any>, payload: any) {
      const authModel = payload.data as AuthenticateModel
      context.commit("authInitiated", { authModel: authModel })

      let rep = await ajax.post<AbpApiResponse<AuthenticateResultModel>>("/api/TokenAuth/Authenticate", payload.data)
      if (rep.data.result == undefined) {
        return rep
      }

      const tokenDurationSec = rep.data.result.expireInSeconds || AppConsts.accessTokenDefaultExpirationSeconds;
      // const tokenDurationSec = 120;
      //const tokenExpireDate = payload.data.rememberMe ? new Date(new Date().getTime() + 1000 * tokenDuration) : undefined;
      const tokenExpireDate = new Date(new Date().getTime() + 1000 * tokenDurationSec)

      util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate)
      util.abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, util.abp.appPath)
      util.abp.utils.setCookieValue("userId", rep.data.result.userId, tokenExpireDate, util.abp.appPath)

      // store token values
      context.commit("tokenExpiration", { tokenExpDate: tokenExpireDate })
      context.commit("tokenDuration", { tokenDurationSeconds: tokenDurationSec })
      //localStorage.setItem(appconst.authorization.tokenDurationSecondsName, tokenDurationSec.toString());
      abp.log.debug({ "Authenticate result": rep.data.result })

      // IMPORTANT: must reload app on login.
      location.reload(true)

      return rep
    },
   
    async submitContactUs(content: ActionContext<AppState, any>, payload: any) {
      await ajax.post("/api/services/app/ContactUsService/CreateContactUs", payload.data)
    },
    async validatePostalAddress(content: ActionContext<AppState, any>, payload: any) {
      let rep = await ajax.post("/api/services/app/GeoLocations/ValidateCityStatePostalCode", payload)
      return rep.data && rep.data.result ? rep.data.result : null
    },

    // Actions moved from "index.ts" store file.
    //TODO: Pavel, move this action to vcponlineok. -vm
    backToSummary(content: any) {
      if (!!content.state.from) {
        router.push({ path: content.state.from.path, query: content.state.from.query || {} })
      } else {
        router.push({
          path: "/App/SubmitApplicationToOkVCP/Vue/ApplicationSummaryStep",
          query: { applicationId: router.app.$route.query.applicationId },
        })
      }
    },
  }
}

const app = new AppStore()
export default app
